import { createSlice } from '@reduxjs/toolkit';
// import { validateNationalIdNumberFormat } from '../../library/national-id';

const initialState = {
    meta: {
        pageNumber: 1,
        pageSize: 20,
        itemTotal: 0
    },
    list: [],
    selectedActivityLog: {
        _id: undefined,
        accountManager: undefined
    },
    activitylogAdded: false,
    activitylogUpdated: false,
    activitylogRemoved: false,
};

const activitylogsSlice = createSlice({
    name: 'activitylogs',
    initialState,
    reducers: {
        getActivityLogs(state, action) {
            state.list = action.payload.logs;
            state.meta = action.payload.meta
        },
        viewActivityLog(state, action) {
            state.selectedActivityLog = action.payload;
        },
        addActivityLog(state, action) {
            state.activitylogAdded = true
        },
        updateActivityLog(state, action) {
            state.activitylogUpdated = true
        },
        removeActivityLog(state, action) {
            state.activitylogRemoved = true
        },
        reset: (state) => initialState,
        logout: (state) => initialState,
    },
});

export const activitylogsActions = activitylogsSlice.actions;
export default activitylogsSlice;
